import NumberFlow from '@number-flow/react';
import { useState, useEffect } from 'react';

const AnimatedNumber = ({ value, delay = 2000, isVisible = false, ...props }) => {
  const [showNumber, setShowNumber] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setShowNumber(true);
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [isVisible, delay]);

  return <NumberFlow value={showNumber ? value || 0 : 0} {...props} />;
};

export default AnimatedNumber;
